const AUTHTOKEN_LOGOUT = "AUTHTOKEN_LOGOUT";
const INVOICES_REQUEST = "INVOICES_REQUEST";
const INVOICES_ERROR = "INVOICES_ERROR";
const INVOICES_SUCCESS = "INVOICES_SUCCESS";
const GENERATE_CSV = "GENERATE_CSV";
const GENERATE_CSV_SUCCESS = "GENERATE_CSV_SUCCESS";
const GENERATE_CSV_ERROR = "GENERATE_CSV_ERROR";
const UPLOAD_MAP = "UPLOAD_MAP";
const UPLOAD_MAP_SUCCESS = "UPLOAD_MAP_SUCCESS";
const UPLOAD_MAP_ERROR = "UPLOAD_MAP_ERROR";
const GENERAL_UPLOAD = "GENERAL_UPLOAD";
const GENERAL_UPLOAD_SUCCESS = "GENERAL_UPLOAD_SUCCESS";
const GENERAL_UPLOAD_ERROR = "GENERAL_UPLOAD_ERROR";
const GENERAL_UPLOAD_UPDATE = "GENERAL_UPLOAD_UPDATE"
const GENERAL_UPLOAD_UPDATE_SUCCESS = "GENERAL_UPLOAD_UPDATE_SUCCESS"
const GENERAL_UPLOAD_UPDATE_ERROR = "GENERAL_UPLOAD_UPDATE_ERROR"
const GENERAL_FILE_DOWNLOAD = 'GENERAL_FILE_DOWNLOAD'
const GENERAL_FILE_DOWNLOAD_SUCCESS = 'GENERAL_FILE_DOWNLOAD_SUCCESS'
const GENERAL_FILE_DOWNLOAD_ERROR = 'GENERAL_FILE_DOWNLOAD_ERROR'
const GENERAL_UPLOAD_DELETE = "GENERAL_UPLOAD_DELETE"
const GENERAL_UPLOAD_DELETE_SUCCESS = "GENERAL_UPLOAD_DELETE_SUCCESS"
const GENERAL_UPLOAD_DELETE_ERROR = "GENERAL_UPLOAD_DELETE_ERROR"
const INVOICE_UPLOAD = "INVOICE_UPLOAD"
const INVOICE_UPLOAD_SUCCESS = "INVOICE_UPLOAD_SUCCESS"
const INVOICE_UPLOAD_ERROR = "INVOICE_UPLOAD_ERROR"
const PO_UPLOAD = "PO_UPLOAD"
const PO_UPLOAD_SUCCESS = "PO_UPLOAD_SUCCESS"
const PO_UPLOAD_ERROR = "PO_UPLOAD_ERROR"
const PO_REQUEST = "PO_REQUEST"
const PO_REQUEST_SUCCESS = "PO_REQUEST_SUCCESS"
const PO_REQUEST_ERROR = "PO_REQUEST_ERROR"
const PO_UPDATE = "PO_UPDATE"
const PO_UPDATE_SUCCESS = "PO_UPDATE_SUCCESS"
const PO_UPDATE_ERROR = "PO_UPDATE_ERROR"
const PO_DELETE = "PO_DELETE"
const PO_DELETE_SUCCESS = "PO_DELETE_SUCCESS"
const PO_DELETE_ERROR = "PO_DELETE_ERROR"
const PO_DOWNLOAD = "PO_DOWNLOAD"
const PO_DOWNLOAD_SUCCESS = "PO_DOWNLOAD_SUCCESS"
const PO_DOWNLOAD_ERROR = "PO_DOWNLOAD_ERROR"
const INVOICE_DOWNLOAD = "INVOICE_DOWNLOAD"
const INVOICE_DOWNLOAD_SUCCESS = "INVOICE_DOWNLOAD"
const INVOICE_DOWNLOAD_ERROR = "INVOICE_DOWNLOAD_ERROR"
const INVOICE_UPDATE = "INVOICE_UPDATE"
const INVOICE_UPDATE_SUCCESS = "INVOICE_UPDATE_SUCCESS"
const INVOICE_UPDATE_ERROR = "INVOICE_UPDATE_ERROR"
const INVOICE_DELETE = "INVOICE_DELETE"
const INVOICE_DELETE_SUCCESS = "INVOICE_DELETE"
const INVOICE_DELETE_ERROR = "INVOICE_DELETE"



import Vue from "vue";

const state = { status: "", invoices: [] };

const getters = {
    getInvoice: (state)=> (invoiceid) => {
       let matchingInvoice = state.invoices.find(invoice => invoice.invoiceid === invoiceid)
      return matchingInvoice
    },
    getInvoiceByNumber: (state)=> (invoicenumber) => {
       let matchingInvoice = state.invoices.find(invoice => invoice.invoicenumber === invoicenumber)
      return matchingInvoice
    },
    getInvoices: state => state.invoices,
    getInvoicesStatus: state => state.status

};

const actions = {
    [INVOICES_REQUEST]: ({ commit, dispatch }) => {
        return new Promise((resolve, reject) => {
            commit(INVOICES_REQUEST);
            commit('addLoading', {handle:'invoices',name:'Load Invoices data'})


            let loginDetails = {
                method: 'GET',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
            //    body: JSON.stringify(payload)
            };
                        
            fetch(Vue.prototype.$apiServer + 'invoices/json', loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                        commit('removeLoading', 'invoices')
                        if (resp.result === 'Success') {
                            resolve(resp.payload)
                             commit(INVOICES_SUCCESS)
/*                             if(Array.isArray(resp.payload)) {
                                commit(INVOICES_SUCCESS, resp)
                            } */
                            resolve(resp)
                        } else {
                            commit(INVOICES_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit(INVOICES_ERROR);
                    commit('removeLoading', 'invoices')
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })            
                }
            })
        })
    },
    [INVOICE_UPDATE]: ({ commit, dispatch }, payload) => {
        return new Promise((resolve, reject) => {
            commit(INVOICE_UPDATE);
            commit('addLoading', {handle:'invoiceupdate',name:'Updating Invoice'})

            let loginDetails = {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
                body: JSON.stringify(payload)
            };
                        
            fetch(Vue.prototype.$apiServer + 'invoice/' + payload.invoiceid, loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                        commit('removeLoading', 'invoiceupdate')
                        if (resp.result === 'Success') {
                             commit(INVOICE_UPDATE_SUCCESS)
                            resolve(resp)
                        } else {
                            commit(INVOICE_UPDATE_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit(INVOICE_UPDATE_ERROR);
                    commit('removeLoading', 'invoiceupdate')
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })            
                }
            })
        })
    },
    [GENERATE_CSV]: ({commit, dispatch}, payload) => {
            return new Promise((resolve, reject) => {
                commit(GENERATE_CSV);
                commit('addLoading', {handle: 'generatecsv', name: 'Creating CSV File '})


                let loginDetails = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
                    body: JSON.stringify(payload)
                };
                            
                fetch(Vue.prototype.$apiServer + 'generatecsv', loginDetails).then(response =>{
                    if(response.ok){ //Successful response and payload
                        response.blob().then(resp => {
                           commit('removeLoading', 'generatecsv')
                            const downloadUrl = window.URL.createObjectURL(new Blob([resp]));

                            const link = document.createElement('a');

                            link.href = downloadUrl;

                            link.setAttribute('download', payload.title + ' .csv'); //any other extension

                            document.body.appendChild(link);

                            link.click();
                            link.remove();

                            Vue.prototype.$snotify.success(
                                "Report Generated",
                                {
                                timeout: 2000,
                                showProgressBar: false,
                                closeOnClick: false,
                                pauseOnHover: true,
                                }
                            );
                            resolve(resp)
                        })
                    } else { //Error
                        commit(GENERATE_CSV_ERROR);
                        commit('removeLoading', 'generatecsv')
                        if (response.status == '403') {
                            dispatch(AUTHTOKEN_LOGOUT);
                        } 
                        response.json().then(err => {
                            reject(err)
                        })            
                    }
                })
            })
        },
        [UPLOAD_MAP]: ({commit, dispatch}, payload) => {
            return new Promise((resolve, reject) => {
                commit(UPLOAD_MAP);
                commit('addLoading', {handle: 'uploadmap', name: 'Updating Map File '})
                const formData = new FormData();
                formData.append('kmzfile', payload.kmzfile);
                
                let loginDetails = {
                    method: 'POST',
                    headers: {'X-Auth-Token': Vue.prototype.$token },
                    body: formData
                };
                            
                fetch(Vue.prototype.$apiServer + 'mapupload', loginDetails).then(response =>{
                    if(response.ok){ //Successful response and payload
                        response.json().then(resp => {
                           commit('removeLoading', 'uploadmap')
                            Vue.prototype.$snotify.success(
                                "Fibre Map Updated",
                                {
                                timeout: 2000,
                                showProgressBar: false,
                                closeOnClick: false,
                                pauseOnHover: true,
                                }
                            );
                            resolve(resp)
                        })
                    } else { //Error
                        commit(UPLOAD_MAP_ERROR);
                        commit('removeLoading', 'uploadmap')
                        if (response.status == '403') {
                            dispatch(AUTHTOKEN_LOGOUT);
                        } 
                        response.json().then(err => {
                            reject(err)
                        })            
                    }
                })
            })
        },
        [GENERAL_UPLOAD]: ({commit, dispatch}, payload) => {
            return new Promise((resolve, reject) => {
                commit(GENERAL_UPLOAD);
                commit('addLoading', {handle: 'uploadfile', name: 'Uploading File'})
                const formData = new FormData();
                formData.append('generalfile', payload.generalfile);
                formData.append('uploadtype', payload.uploadtype);
                formData.append('customerid', payload.customerid)
                
                let loginDetails = {
                    method: 'POST',
                    headers: {'X-Auth-Token': Vue.prototype.$token },
                    body: formData
                };
                            
                fetch(Vue.prototype.$apiServer + 'generalupload', loginDetails).then(response =>{
                    commit(GENERAL_UPLOAD_SUCCESS)
                    if(response.ok){ //Successful response and payload
                        response.json().then(resp => {
                           commit('removeLoading', 'uploadfile')
                            Vue.prototype.$snotify.success(
                                "File Uploaded!",
                                {
                                timeout: 2000,
                                showProgressBar: false,
                                closeOnClick: false,
                                pauseOnHover: true,
                                }
                            );
                            resolve(resp)
                        })
                    } else { //Error
                        commit(GENERAL_UPLOAD_ERROR);
                        commit('removeLoading', 'uploadmap')
                        if (response.status == '403') {
                            dispatch(AUTHTOKEN_LOGOUT);
                        } 
                        response.json().then(err => {
                            reject(err)
                        })            
                    }
                })
            })
        },
    [GENERAL_UPLOAD_UPDATE]: ({ commit, dispatch }, payload) => {
        return new Promise((resolve, reject) => {
            commit(GENERAL_UPLOAD_UPDATE);
            commit('addLoading', {handle:'generaluploadupdated',name:'Updating File Data'})


            let loginDetails = {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
                body: JSON.stringify(payload)
            };
                        
            fetch(Vue.prototype.$apiServer + 'generalupload/' + payload.uploadid, loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                        commit('removeLoading', 'generaluploadupdated')
                        if (resp.result === 'Success') {
                            resolve(resp)
                        } else {
                            commit(GENERAL_UPLOAD_UPDATE_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit(GENERAL_UPLOAD_UPDATE_ERROR);
                    commit('removeLoading', 'generaluploadupdated')
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })            
                }
            })
        })
    },

    [GENERAL_FILE_DOWNLOAD]: ({commit, dispatch}, payload) => {
        return new Promise((resolve, reject) => {
            commit(GENERAL_FILE_DOWNLOAD);
            commit('addLoading', {handle: 'downloadFile', name: 'Retrieving File'})


            let loginDetails = {
                method: 'GET',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
            //    body: JSON.stringify(payload)
            };
                        
            fetch(Vue.prototype.$apiServer + 'generalupload/' + payload.uploadid + '/pdf', loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.blob().then(resp => {
                        commit(GENERAL_FILE_DOWNLOAD_SUCCESS);
                        commit('removeLoading', 'downloadFile')
                        const downloadUrl = window.URL.createObjectURL(new Blob([resp]));

                        const link = document.createElement('a');

                        link.href = downloadUrl;

                        link.setAttribute('download', payload.uploadtype + '.pdf'); //any other extension

                        document.body.appendChild(link);

                        link.click();
                        link.remove();

                        Vue.prototype.$snotify.success(
                            "File Downloaded",
                            {
                            timeout: 2000,
                            showProgressBar: false,
                            closeOnClick: false,
                            pauseOnHover: true,
                            }
                        );
                        resolve(resp)
                    })
                } else { //Error
                    commit(GENERAL_FILE_DOWNLOAD_ERROR);
                    commit('removeLoading', 'downloadFile')
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })            
                }
            })
        })
    },

    [GENERAL_UPLOAD_DELETE]: ({ commit, dispatch }, uploadid) => {
        return new Promise((resolve, reject) => {
            commit(GENERAL_UPLOAD_DELETE);
            commit('addLoading', {handle: 'deleteUpload', name: 'Deleting Upload'})

            let loginDetails = {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
            //    body: JSON.stringify(payload)
            };
                            
            fetch(Vue.prototype.$apiServer + '/generalupload/' + uploadid, loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                    commit('removeLoading', 'deleteUpload')
                        if (resp.result === 'Success') {
                            commit(GENERAL_UPLOAD_DELETE_SUCCESS)
                            resolve(resp)
                        } else {
                            commit(GENERAL_UPLOAD_DELETE_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit(GENERAL_UPLOAD_DELETE_ERROR);
                    commit('removeLoading', 'deleteUpload')
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })        
                }
            })
        })
    },


    [INVOICE_UPLOAD]: ({commit, dispatch}, payload) => {
        return new Promise((resolve, reject) => {
            commit(INVOICE_UPLOAD);
            commit('addLoading', {handle: 'uploadfile', name: 'Uploading File'})
            const formData = new FormData();
            formData.append('invoicefile', payload.invoicefile);
            formData.append('invoicenumber', payload.invoicenumber);
            formData.append('customerid', payload.customerid);
            formData.append('invoicedate', payload.invoicedate);
            formData.append('totalcostincgst', payload.totalcostincgst);
            formData.append('totalcostexcgst', payload.totalcostexcgst);
            
            let loginDetails = {
                method: 'POST',
                headers: {'X-Auth-Token': Vue.prototype.$token },
                body: formData
            };
                        
            fetch(Vue.prototype.$apiServer + 'invoice', loginDetails).then(response =>{
                commit(INVOICE_UPLOAD_SUCCESS)
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                        commit('removeLoading', 'uploadfile')
                        dispatch(INVOICES_REQUEST)
                        Vue.prototype.$snotify.success(
                            "Invoice Uploaded",
                            {
                            timeout: 2000,
                            showProgressBar: false,
                            closeOnClick: false,
                            pauseOnHover: true,
                            }
                        );
                        resolve(resp)
                    })
                } else { //Error
                    commit(INVOICE_UPLOAD_ERROR);
                    commit('removeLoading', 'uploadmap')
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })            
                }
            })
        })
    },

    [INVOICE_DOWNLOAD]: ({commit, dispatch}, payload) => {
        return new Promise((resolve, reject) => {
            commit(INVOICE_DOWNLOAD);
            commit('addLoading', {handle: 'downloadFile', name: 'Retrieving File'})

            let loginDetails = {
                method: 'GET',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
            //    body: JSON.stringify(payload)
            };
                        
            fetch(Vue.prototype.$apiServer + 'invoice/' + payload.invoiceid + '/pdf', loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.blob().then(resp => {
                        commit(INVOICE_DOWNLOAD_SUCCESS);
                        commit('removeLoading', 'downloadFile')
                        const downloadUrl = window.URL.createObjectURL(new Blob([resp]));

                        const link = document.createElement('a');

                        link.href = downloadUrl;

                        link.setAttribute('download', 'VERNet Invoice #' +payload.invoicenumber + '.pdf'); //any other extension

                        document.body.appendChild(link);

                        link.click();
                        link.remove();

                        Vue.prototype.$snotify.success(
                            "File Downloaded",
                            {
                            timeout: 2000,
                            showProgressBar: false,
                            closeOnClick: false,
                            pauseOnHover: true,
                            }
                        );
                        resolve(resp)
                    })
                } else { //Error
                    commit(INVOICE_DOWNLOAD_ERROR);
                    commit('removeLoading', 'downloadFile')
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })            
                }
            })
        })
    },

    [INVOICE_DELETE]: ({ commit, dispatch }, invoiceid) => {
        return new Promise((resolve, reject) => {
            commit(INVOICE_DELETE);
            commit('addLoading', {handle: 'deleteInvoice', name: 'Deleting Invoice'})

            let loginDetails = {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
            //    body: JSON.stringify(payload)
            };
                            
            fetch(Vue.prototype.$apiServer + '/invoice/' + invoiceid, loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                    commit('removeLoading', 'deleteInvoice')
                        if (resp.result === 'Success') {
                            commit(INVOICE_DELETE_SUCCESS)
                            dispatch(INVOICES_REQUEST)
                            resolve(resp)
                        } else {
                            commit(INVOICE_DELETE_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit(INVOICE_DELETE_ERROR);
                    commit('removeLoading', 'deleteInvoice')
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })        
                }
            })
        })
    },
    [PO_REQUEST]: ({ commit, dispatch }) => {
        return new Promise((resolve, reject) => {
            commit(PO_REQUEST);
            commit('addLoading', {handle:'getOrders',name:'Load Purchase Orders'})

            let loginDetails = {
                method: 'GET',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
            //    body: JSON.stringify(payload)
            };
            fetch(Vue.prototype.$apiServer + 'purchaseorders/json', loginDetails).then(response =>{
                commit('removeLoading', 'getOrders')
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                        if (resp.result === 'Success') {
                            commit(PO_REQUEST_SUCCESS)
                            resolve(resp.payload)
                        } else {
                            commit(PO_REQUEST_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit(PO_REQUEST_ERROR);
                    commit('removeLoading', 'getOrders')
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })            
                }
            })
        })
    },
    [PO_UPLOAD]: ({commit, dispatch}, payload) => {
        return new Promise((resolve, reject) => {
            commit(PO_UPLOAD);
            commit('addLoading', {handle: 'uploadfile', name: 'Uploading File'})
            const formData = new FormData();
            formData.append('purchaseorderfile', payload.purchaseorderfile);
            formData.append('ponumber', payload.ponumber);
            formData.append('customerid', payload.customerid);
            formData.append('podate', payload.podate);
            formData.append('servicetower', payload.servicetower);
            formData.append('servicereferencenumber', payload.servicereferencenumber);
            formData.append('pricepermonth', payload.pricepermonth);
            formData.append('quantity', payload.quantity);
            formData.append('serviceterm', payload.serviceterm);
            
            let loginDetails = {
                method: 'POST',
                headers: {'X-Auth-Token': Vue.prototype.$token },
                body: formData
            };
                        
            fetch(Vue.prototype.$apiServer + 'purchaseorder', loginDetails).then(response =>{
                commit(PO_UPLOAD_SUCCESS)
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                        commit('removeLoading', 'uploadfile')
                        Vue.prototype.$snotify.success(
                            "Purchase Order Uploaded!",
                            {
                            timeout: 2000,
                            showProgressBar: false,
                            closeOnClick: false,
                            pauseOnHover: true,
                            }
                        );
                        resolve(resp)
                    })
                } else { //Error
                    commit(PO_UPLOAD_ERROR);
                    commit('removeLoading', 'uploadmap')
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })            
                }
            })
        })
    },
    [PO_DOWNLOAD]: ({commit, dispatch}, payload) => {
        return new Promise((resolve, reject) => {
            commit(PO_DOWNLOAD);
            commit('addLoading', {handle: 'downloadFile', name: 'Retrieving Purchase Order'})

            let loginDetails = {
                method: 'GET',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
            //    body: JSON.stringify(payload)
            };
                        
            fetch(Vue.prototype.$apiServer + 'purchaseorder/' + payload.poid + '/pdf', loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.blob().then(resp => {
                        commit(PO_DOWNLOAD_SUCCESS);
                        commit('removeLoading', 'downloadFile')
                        const downloadUrl = window.URL.createObjectURL(new Blob([resp]));

                        const link = document.createElement('a');

                        link.href = downloadUrl;

                        link.setAttribute('download', 'VERNet Purchase Order - ' +payload.ponumber + '.pdf'); //any other extension

                        document.body.appendChild(link);

                        link.click();
                        link.remove();

                        Vue.prototype.$snotify.success(
                            "File Downloaded",
                            {
                            timeout: 2000,
                            showProgressBar: false,
                            closeOnClick: false,
                            pauseOnHover: true,
                            }
                        );
                        resolve(resp)
                    })
                } else { //Error
                    commit(PO_DOWNLOAD_ERROR);
                    commit('removeLoading', 'downloadFile')
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })            
                }
            })
        })
    },
    [PO_UPDATE]: ({ commit, dispatch }, payload) => {
        return new Promise((resolve, reject) => {
            commit(PO_UPDATE);
            commit('addLoading', {handle:'poupdate',name:'Updating Purchase Order'})

            let loginDetails = {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
                body: JSON.stringify(payload)
            };
                        
            fetch(Vue.prototype.$apiServer + 'purchaseorder/' + payload.poid, loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                        commit('removeLoading', 'poupdate')
                        if (resp.result === 'Success') {
                             commit(PO_UPDATE_SUCCESS)
                            resolve(resp)
                        } else {
                            commit(PO_UPDATE_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit(PO_UPDATE_ERROR);
                    commit('removeLoading', 'poupdate')
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })            
                }
            })
        })
    },
    [PO_DELETE]: ({ commit, dispatch }, poid) => {
        return new Promise((resolve, reject) => {
            commit(PO_DELETE);
            commit('addLoading', {handle: 'deletePO', name: 'Deleting Purchase Order'})

            let loginDetails = {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
            //    body: JSON.stringify(payload)
            };
                            
            fetch(Vue.prototype.$apiServer + '/purchaseorder/' + poid, loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                    commit('removeLoading', 'deletePO')
                        if (resp.result === 'Success') {
                            commit(PO_DELETE_SUCCESS)
                            resolve(resp)
                        } else {
                            commit(PO_DELETE_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit(PO_DELETE_ERROR);
                    commit('removeLoading', 'deletePO')
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })        
                }
            })
        })
    },

};

const mutations = {
    [INVOICES_REQUEST]: state => {
        state.invoicesstatus = "loading";
        Vue.set(state, "invoices", {});
    },
    [INVOICES_SUCCESS]: (state) => {
        state.invoicesstatus = "success";
/*         resp.payload.forEach(thisInvoice => {
            let thisDate = new Date(parseFloat(thisInvoice.invoicedate)*1000);
            thisInvoice.invoiceyear = thisDate.getFullYear();
            thisInvoice.invoicemonth = thisDate.getMonth() + 1;
            thisInvoice.invoiceday = thisDate.getDate();
        })
        Vue.set(state, "invoices", resp.payload); */
    },
    [INVOICES_ERROR]: state => {
    //    state.status = "error";
        Vue.set(state, "invoices", "error");
    },
    [GENERATE_CSV]: state => {
        Vue.set(state, "csv", "loading");
    },
    [GENERATE_CSV_SUCCESS]: state => {
        Vue.set(state, "csv", "success");
    },
    [GENERATE_CSV_ERROR]: state => {
        Vue.set(state, "csv", "error");
    },
    [UPLOAD_MAP]: state => {
        Vue.set(state, "status", "loading");
    },
    [UPLOAD_MAP_SUCCESS]: state => {
        Vue.set(state, "status", "success");
    },
    [UPLOAD_MAP_ERROR]: state => {
        Vue.set(state, "status", "error");
    },
    [GENERAL_UPLOAD_UPDATE]: state => {
        Vue.set(state, "status", "loading");
    },
    [GENERAL_UPLOAD_UPDATE_SUCCESS]: state => {
        Vue.set(state, "status", "success");
    },
    [GENERAL_UPLOAD_UPDATE_ERROR]: state => {
        Vue.set(state, "status", "error");
    },
    [GENERAL_FILE_DOWNLOAD]: state => {
        Vue.set(state, "status", "loading");
    },
    [GENERAL_FILE_DOWNLOAD_SUCCESS]: state => {
        Vue.set(state, "status", "success");
    },
    [GENERAL_FILE_DOWNLOAD_ERROR]: state => {
        Vue.set(state, "status", "error");
    },
    [GENERAL_UPLOAD_DELETE]: state => {
        Vue.set(state, "status", "loading");
    },
    [GENERAL_UPLOAD_DELETE_SUCCESS]: state => {
        Vue.set(state, "status", "success");
    },
    [GENERAL_UPLOAD_DELETE_ERROR]: state => {
        Vue.set(state, "status", "error");
    },
    [INVOICE_UPLOAD]: state => {
        Vue.set(state, "status", "loading");
    },
    [INVOICE_UPLOAD_SUCCESS]: state => {
        Vue.set(state, "status", "success");
    },
    [INVOICE_UPLOAD_ERROR]: state => {
        Vue.set(state, "status", "error");
    },
    [INVOICE_UPDATE]: state => {
        Vue.set(state, "status", "loading");
    },
    [INVOICE_UPDATE_SUCCESS]: state => {
        Vue.set(state, "status", "success");
    },
    [INVOICE_UPDATE_ERROR]: state => {
        Vue.set(state, "status", "error");
    },
    [INVOICE_DOWNLOAD]: state => {
        Vue.set(state, "status", "loading");
    },
    [INVOICE_DOWNLOAD_SUCCESS]: state => {
        Vue.set(state, "status", "success");
    },
    [INVOICE_DOWNLOAD_ERROR]: state => {
        Vue.set(state, "status", "error");
    },
    [INVOICE_DELETE]: state => {
        Vue.set(state, "status", "loading");
    },
    [INVOICE_DELETE_SUCCESS]: state => {
        Vue.set(state, "status", "success");
    },
    [INVOICE_DELETE_ERROR]: state => {
        Vue.set(state, "status", "error");
    },
    [PO_UPLOAD]: state => {
        Vue.set(state, "status", "loading");
    },
    [PO_UPLOAD_SUCCESS]: state => {
        Vue.set(state, "status", "success");
    },
    [PO_UPLOAD_ERROR]: state => {
        Vue.set(state, "status", "error");
    },
    [PO_REQUEST]: state => {
        Vue.set(state, "status", "loading");
    },
    [PO_REQUEST_SUCCESS]: state => {
        Vue.set(state, "status", "success");
    },
    [PO_REQUEST_ERROR]: state => {
        Vue.set(state, "status", "error");
    },
    [PO_UPDATE]: state => {
        Vue.set(state, "status", "loading");
    },
    [PO_UPDATE_SUCCESS]: state => {
        Vue.set(state, "status", "success");
    },
    [PO_UPDATE_ERROR]: state => {
        Vue.set(state, "status", "error");
    },
    [PO_DELETE]: state => {
        Vue.set(state, "status", "loading");
    },
    [PO_DELETE_SUCCESS]: state => {
        Vue.set(state, "status", "success");
    },
    [PO_DELETE_ERROR]: state => {
        Vue.set(state, "status", "error");
    },
    [PO_DOWNLOAD]: state => {
        Vue.set(state, "status", "loading");
    },
    [PO_DOWNLOAD_SUCCESS]: state => {
        Vue.set(state, "status", "success");
    },
    [PO_DOWNLOAD_ERROR]: state => {
        Vue.set(state, "status", "error");
    },
    [AUTHTOKEN_LOGOUT]: state => {
        state.invoices = {};
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};